import HttpClient from './http';

const getHighestWins = (skinId: number, range: { dateFrom: string; dateTo: string }): Promise<any> => {
  const params = new URLSearchParams();
  params.append('skinId', String(skinId));

  params.append('dateFrom', String(range.dateFrom.toString()));
  params.append('dateTo', String(range.dateTo.toString()));

  return HttpClient.get({
    path: `/api/getBetWinVisualFeed?${params.toString()}`,
    baseURL: process.env.REACT_APP_REPORTS as string,
  });
};

export { getHighestWins };
